// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetLessonLecturerAssignmentStatusLookupRequestModel from '../../model/get-lesson-lecturer-assignment-status-lookup-request-model';
import GetLessonLecturerAssignmentStatusLookupRequestDTO from '../dto/get-lesson-lecturer-assignment-status-lookup-request-dto';
import dtoSchema from '../schemas/get-lesson-lecturer-assignment-status-lookup-request-schema';

export default abstract class GetLessonLecturerAssignmentStatusLookupRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetLessonLecturerAssignmentStatusLookupRequestDTO>) {
    super();
  }

  static toModel(dto: DeepPartial<GetLessonLecturerAssignmentStatusLookupRequestDTO>): GetLessonLecturerAssignmentStatusLookupRequestModel;
  static toModel(dto: DeepPartial<GetLessonLecturerAssignmentStatusLookupRequestDTO> | undefined | null): GetLessonLecturerAssignmentStatusLookupRequestModel | undefined;
  static toModel(dto: DeepPartial<GetLessonLecturerAssignmentStatusLookupRequestDTO> | undefined | null): GetLessonLecturerAssignmentStatusLookupRequestModel | undefined {
    return dto ? new GetLessonLecturerAssignmentStatusLookupRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetLessonLecturerAssignmentStatusLookupRequestModel> | GetLessonLecturerAssignmentStatusLookupRequestModel): GetLessonLecturerAssignmentStatusLookupRequestDTO {
    const dto = {
    } as GetLessonLecturerAssignmentStatusLookupRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetLessonLecturerAssignmentStatusLookupRequestModel, can not map to GetLessonLecturerAssignmentStatusLookupRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
